{ attachmentsDomain } = require '@trello/config'

module.exports = (url) ->
  url.indexOf(attachmentsDomain) == 0
